import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleWithoutColor'
})
export class TitleWithoutColorPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {

    // color will be inside () so we need to remove it and the parentheses
    if (typeof value === 'string') {
      const colorIndex = value.indexOf('(');
      if (colorIndex > -1) {
        return value.slice(0, colorIndex - 1);
      }
      return value;
    }
    return value;
  }

}
